import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import backgroundPic from "../../assets/background.jpg";
import stat2024 from "../../assets/gallery/文聚冊市/square.jpg";
import kemooMain from "../../assets/design/kemoo/square_kemoo.jpg";
import monster02 from "../../assets/shop/nail/square_monster.jpg";
import MainPageCard from "../../component/mainPageCard";
import bear from "../../assets/bear.gif";
import rrrr from "../../assets/rrrr_LOGO.png";
import about_me from "../../assets/about_me.png";
import flower from "../../assets/flower.png";
import { Link } from "react-router-dom";
import bee from "../../assets/bee.gif";  // Ensure bee image is imported

const LandingPage = () => {
    const [isVisible, setIsVisible] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setIsVisible(false);
        const timer = setTimeout(() => setIsVisible(true), 10);
        return () => clearTimeout(timer);
    }, [location]);

    return (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
            {/* First Section */}
            <section
                style={{
                    position: "relative",
                    height: "100vh",
                    width: "100%",
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    textAlign: "center",
                    color: "#fff",
                    opacity: isVisible ? 1 : 0,
                    transition: "opacity 2s ease-out",
                }}
            >
                <img
                    src={backgroundPic}
                    alt="Background"
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover", // maintains aspect ratio, no cropping
                        zIndex: -1,
                    }}
                />

                {/* <h1 style={{
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: "2.5rem",
                    fontWeight: "bold",
                    // textShadow: "2px 2px 0px #666, 2px 2px 0px #222",
                    position: "relative",
                    zIndex: 1,
                }}>
                    sanaxillu
                </h1> */}

                <img
                    src={bear}
                    alt="Bear"
                    style={{
                        position: "absolute",
                        bottom: "220px",
                        left: "120px",
                        width: "120px",
                        height: "auto",
                        zIndex: 1,
                    }}
                />
            </section>
            {/* Second Section (Images Layout) */}
            <section
                style={{
                    height: "50vh",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    padding: "60px 10%",
                    backgroundColor: "#fdfdfd",
                    flexWrap: "wrap",
                    position: "relative",
                }}
            >
                {/* Left side: about me + rrrr */}
                <div style={{ position: "relative", maxWidth: "45%" }}>
                    {/* <Link to="/about" style={{ display: "block", marginTop: "40px", position: "relative", zIndex: 3 }}> */}
                    <img
                        src={rrrr}
                        alt="rrrr"
                        style={{
                            width: "40%",
                            position: "absolute",
                            top: 15,
                            left: -20,
                            borderRadius: "12px",
                            zIndex: 1,
                            backgroundColor: "transparent",
                            mixBlendMode: "multiply",
                        }}
                    />
                    {/* </Link> */}
                    <img
                        src={about_me}
                        alt="About Me"
                        style={{
                            marginTop: "-50px",
                            width: "40%",
                            borderRadius: "12px",
                            zIndex: 2,
                            position: "relative",
                            backgroundColor: "transparent",
                            mixBlendMode: "multiply",
                        }}
                    />
                    {/* Text Block */}
                    <div style={{
                        position: "absolute",
                        top: "50%",
                        left: "55%", // adjust as needed
                        transform: "translateY(-10%)",
                        padding: "16px 24px",
                        width: "750px",
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                        borderRadius: "12px",
                        fontSize: "13px",
                        lineHeight: "1.6",
                        color: "#333",
                        zIndex: 2,
                    }}>
                        我喜歡觀察日常裡的小細節，用溫柔的線條和柔和的色彩，把生活中那些幽默、有趣、甚至有點詩意的瞬間畫下來。<br /><br />
                        創作對我來說，是一種情感的記錄。我喜歡透過圖像捕捉情感與氛圍，讓觀者在視覺中感受到情緒的流動，並與作品產生共鳴。<br /><br />

                        <span style={{ color: "#666", fontSize: "14px" }}>
                            I enjoy observing small details in everyday life, using gentle lines and soft colours to capture moments that are humorous, touching, or quietly poetic. <br /><br />
                            For me, illustration is a way of recording emotions. I like to express feelings and atmosphere through images, allowing viewers to sense an emotional flow and connect with the work on a more personal level.
                        </span>
                    </div>
                    <img
                        src={flower}
                        alt="Flower"
                        style={{
                            position: "absolute",
                            width: "40%",
                            right: -760,
                            borderRadius: "12px",    // align to bottom of container, adjust if you want different vertical alignment
                        }}
                    />
                </div>
            </section>



            {/* Third Section (Cards) */}
            <Box display="flex" justifyContent="center" flexWrap="wrap" gap="100px" marginTop="-30px">
                <MainPageCard title="gallery" image={stat2024} link="/gallery" />
                {/* <MainPageCard title="design" image={kemooMain} link="/design" /> */}
                <MainPageCard title="shop" image={monster02} link="/shop" />
            </Box>
            <Box
                height="100px" // Adjust height as needed
                width="100%"
                marginTop="40px" // Optional spacing
                bgcolor="transparent" // Or use a color like "#f0f0f0"
            ></Box>

            <Box
                sx={{
                    position: "fixed",
                    bottom: "20px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 1000, // Ensure bee stays on top
                }}
            >
                <img
                    src={bee}
                    alt="Bee Icon"
                    style={{
                        width: "100px", // Adjust size as needed
                        height: "auto",
                    }}
                />
            </Box>

        </div>
    );
};

export default LandingPage;
